import { render, staticRenderFns } from "./BaseBadge.vue?vue&type=template&id=d5f37c44&scoped=true&"
var script = {}
import style0 from "./BaseBadge.vue?vue&type=style&index=0&id=d5f37c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f37c44",
  null
  
)

export default component.exports